var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 10.8688C20 15.8602 16.343 19.9973 11.5625 20.7473V13.7594H13.8926L14.3359 10.8688H11.5625V8.99299C11.5625 8.20198 11.95 7.43127 13.1922 7.43127H14.4531V4.97034C14.4531 4.97034 13.3086 4.77502 12.2145 4.77502C9.93047 4.77502 8.4375 6.1594 8.4375 8.66565V10.8688H5.89844V13.7594H8.4375V20.7473C3.65703 19.9973 0 15.8602 0 10.8688C0 5.34612 4.47734 0.868774 10 0.868774C15.5227 0.868774 20 5.34612 20 10.8688Z",
    fill: "#1877F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8926 13.7594L14.3359 10.8688H11.5625V8.99295C11.5625 8.20213 11.9499 7.43127 13.1921 7.43127H14.4531V4.97034C14.4531 4.97034 13.3088 4.77502 12.2146 4.77502C9.93043 4.77502 8.4375 6.1594 8.4375 8.66565V10.8688H5.89844V13.7594H8.4375V20.7473C8.94664 20.8271 9.46844 20.8688 10 20.8688C10.5316 20.8688 11.0534 20.8271 11.5625 20.7473V13.7594H13.8926Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.5a17927c33769e0d57db656c2cd95c6e.svg";
export { ForwardRef as ReactComponent };